import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = ["d"]

import svgJSON from '@/assets/svg.json'
import stylesJS from "@/assets/styles.js"
import styleJSON from "@/assets/style.json"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'expandGroup',
  props: {
  styles: {
    type: String,
    default: ""
  },
  active: {
    type: Boolean,
    default: false
  },
},
  setup(__props) {

const props = __props

const svg = computed(() => {
  return svgJSON.triangleRight
})


const style = computed(() => {
  // Import & defaults
  const importOBJ = stylesJS.get(props.styles)
  const iColor = importOBJ.color || "main"
  const iBg = importOBJ.bg || "bg*0"
  const iSize = importOBJ.size || "m"

  // Common
  let styleOBJ = {}
  styleOBJ.divOuter = [
    {"color" : stylesJS.color(iColor)},
    {"background-color" : stylesJS.color(iBg)},
  ]
  styleOBJ.divInner = [
    {"width" : styleJSON.itemSize[iSize]},
    {"height" : styleJSON.itemSize[iSize]},
    {"transition" : "transform .2s"},
  ]

  // Active
  if (props.active) {styleOBJ.divInner = styleOBJ.divInner.concat(
    {"transform" : "rotate(90deg)"},
  )}

  return styleOBJ
})

return (_ctx: any,_cache: any) => {
  return (svg.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "cursor-action row",
        style: _normalizeStyle(style.value.divOuter)
      }, [
        _createElementVNode("div", {
          class: "row",
          style: _normalizeStyle(style.value.divInner)
        }, [
          (_openBlock(), _createElementBlock("svg", {
            width: "100%",
            preserveAspectRatio: "xMidYMid meet",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            fill: "currentColor",
            viewBox: svg.value.viewBox
          }, [
            _createElementVNode("path", {
              d: svg.value.path
            }, null, 8, _hoisted_2)
          ], 8, _hoisted_1))
        ], 4),
        _renderSlot(_ctx.$slots, "default")
      ], 4))
    : _createCommentVNode("", true)
}
}

})